//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  WritableSignal,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

//local imports
import { ProgramModel } from "@app/catalog";
import { PresenterType } from "@app/shared";

@PresenterType({
  model: ProgramModel,
  key: "tileBottom",
})
@Component({
  selector: 'program-carousel-item-bottom',
  standalone: false,
  templateUrl: './program-carousel-item-bottom.component.html',
  styleUrl: './program-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgramCarouselItemBottomComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  public data: WritableSignal<ProgramModel> = signal<ProgramModel>(undefined);

  public navigateToDetailPage() {
    this.router.navigate(["program", this.data().id], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
    });
  }
}
